<AuthCard>
    <GenericPasswordChangeForm @submit="submit">
        <div class="d-flex justify-space-between">
            <v-btn
                type="submit"
                variant="flat"
                tile
                color="primary"
                :loading="loading">
                Change password
            </v-btn>
            <v-btn variant="text" @click="goToLogin">Back to login</v-btn>
        </div>
    </GenericPasswordChangeForm>

    <BaseDialog
        label="Information"
        :width="300"
        v-model="informationDialog">
        <p>Password successfully changed.</p>
        <v-btn color="primary" variant="flat" tile @click="goToLogin">
            Back to login
        </v-btn>
    </BaseDialog>
</AuthCard>